import { useMemo } from 'react';
import { addMediaMediaSourceSelected } from '@wix/bi-logger-media-manager-g6/v2';

import { bi } from '../../../services/loggers/bi';
import { BiAddMediaClickOrigin } from '../../../constants/Bi';

export const useTrackAddMediaMediaSourceSelected = () =>
  useMemo(
    () => ({
      trackAddMediaMediaSourceSelectedDragAndDrop: (target) =>
        bi.logger().report(addMediaMediaSourceSelected({ clickOrigin: BiAddMediaClickOrigin.DragAndDrop, target })),
      trackAddMediaMediaSourceSelectedImportFilesTabs: (target) =>
        bi.logger().report(addMediaMediaSourceSelected({ clickOrigin: BiAddMediaClickOrigin.ImportFilesTabs, target })),
      trackAddMediaMediaSourceSelectedUploadWidget: (target) =>
        bi.logger().report(addMediaMediaSourceSelected({ clickOrigin: BiAddMediaClickOrigin.UploadWidget, target })),
    }),
    [],
  );
